import type { IntlShape } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import type { JSX } from 'react';
import styles from './styles.module.scss';
import OnePercentForThePlanet from './OnePercentForThePlanet';
import LeaveNoTrace from './LeaveNoTrace';

type Props = {
  intl: IntlShape;
};

const MembersForThePlanet = ({ intl }: Props): JSX.Element => (
  <div className={styles.container}>
    <Typography className={styles.title} component="h2" mt="0" variant="text300bold" color="inverse">
      {intl.formatMessage({ defaultMessage: 'Members for the planet' })}
    </Typography>
    <div className={styles.membersIconsContainer}>
      <OnePercentForThePlanet className={styles.logo} />
      <LeaveNoTrace className={styles.logo} />
    </div>
  </div>
);

export default MembersForThePlanet;
